import Tooltip from '@Components/ServiceTjek/Tooltip';
import React from 'react';

const Image = ({ url, alt, text }) => {
	return (
		<div className="relative">
			<div style={ { position: 'absolute', top: '10px', left: '10px' } }>
				<Tooltip text={ text } />
			</div>
			<img src={ url } alt={ alt } />
		</div>
	);
};

export default Image;
